import { Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, CalendarRange, Mountain, MessageSquare, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { to: "/admin/bookings", label: "Bookings", icon: CalendarRange },
  { to: "/admin/experiences", label: "Experiences", icon: Mountain },
  { to: "/admin/enquiries", label: "Enquiries", icon: MessageSquare },
];

export default function AdminLayout({ children, title }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const isActive = (i) => (i.exact ? location.pathname === i.to : location.pathname.startsWith(i.to));

  return (
    <div className="min-h-screen bg-background font-sans flex">
      <aside className="hidden md:flex w-64 flex-col border-r border-primary/10 bg-secondary/30 p-5 sticky top-0 h-screen">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <span className="grid place-items-center w-8 h-8 rounded-full bg-primary text-primary-foreground font-display leading-none">z</span>
          <span className="font-display text-xl text-foreground">zatayoo</span>
        </Link>
        <nav className="flex-1 space-y-1" data-testid="admin-nav">
          {NAV.map((item) => {
            const Icon = item.icon;
            return (
              <Link key={item.to} to={item.to} data-testid={`admin-nav-${item.label.toLowerCase()}`}
                className={`flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${isActive(item) ? "bg-primary text-primary-foreground" : "text-foreground/70 hover:bg-secondary"}`}>
                <Icon size={18} /> {item.label}
              </Link>
            );
          })}
        </nav>
        <div className="border-t border-primary/10 pt-4 space-y-1">
          <Link to="/" className="flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium text-foreground/70 hover:bg-secondary"><ExternalLink size={18} /> View site</Link>
          <button onClick={() => { logout(); navigate("/"); }} className="w-full flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium text-destructive hover:bg-destructive/10" data-testid="admin-logout"><LogOut size={18} /> Logout</button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <header className="border-b border-primary/10 bg-background sticky top-0 z-10">
          <div className="px-5 md:px-8 h-16 flex items-center justify-between">
            <h1 className="font-semibold text-lg text-foreground">{title}</h1>
            <div className="flex items-center gap-3">
              <span className="text-sm text-muted-foreground hidden sm:block">{user?.email}</span>
              <span className="grid place-items-center w-9 h-9 rounded-full bg-accent text-accent-foreground text-sm font-semibold">{(user?.name || "A")[0]}</span>
            </div>
          </div>
        </header>
        <main className="p-5 md:p-8">{children}</main>
      </div>
    </div>
  );
}
